<div class="details-grid">
  <div class="details__item" *ngFor="let property of displayedAnomalyDetails; let index = index">
    <div class="grid-column grid-column--1"> {{ 'leitstand.anomaly.' + property | translate }}: </div>
    <div class="grid-column grid-column--2"> {{ formatData(property) }} </div>
  </div>
</div>
